import { render, staticRenderFns } from "./LocationEventType.vue?vue&type=template&id=22357a10"
import script from "./LocationEventType.vue?vue&type=script&lang=js"
export * from "./LocationEventType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports